import typeCheck from 'common/util/typeCheck';
import { SR_API_ACTION_METABASE_CHART_GET_BY_PARTNER_ID } from 'api/actionTypes';

export default async function getByPartnerId({ state, apiClient }, { partnerId, reload }) {
  typeCheck('partnerId::PositiveNumber', partnerId);
  typeCheck('reload::Maybe Boolean', reload);

  const metabaseChartsPath = ['metabaseCharts', 'byPartnerId', partnerId];
  const metabaseCharts = state.get(metabaseChartsPath);

  if (metabaseCharts && !reload) {
    return;
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_METABASE_CHART_GET_BY_PARTNER_ID,
    state: state,
    payload: {
      partnerId,
    },
    onSuccess(metabaseCharts) {
      state.set(metabaseChartsPath, metabaseCharts);
    },
  });
}
